import { useState, useEffect } from 'react';
import { CMSAPI } from '../config';

function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name) return decodeURIComponent(cookieValue);
  }
  return null;
}

export function useCartCount() {
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const updateCartCount = async () => {
      const userId = getCookie('userId');

      if (!userId) {
        const guestCart = JSON.parse(getCookie('guestCart') || '[]');
        setCartCount(guestCart.length);
        return;
      }

      try {
        const response = await fetch(
          `${CMSAPI}/api/Website/get-cart-by-user-id?userId=${userId}`
        );
        const data = await response.json();

        const totalCount = data.reduce((sum, item) => sum + (item.quantity || 0), 0);
        setCartCount(totalCount);
      } catch (error) {
        console.error("Error updating cart count:", error);
      }
    };

    // Initial update
    updateCartCount();

    // Optional: Set up an interval to periodically update the count
    const interval = setInterval(updateCartCount, 1000); // Update every 30 seconds

    return () => clearInterval(interval);
  }, []);

  return cartCount;
}